module.exports = __webpack_public_path__ + "img/thumbnail-cedrow-with-table.2375b468.webp";